
const mineStore = {
  namespaced: true,
  state: {
    showAuthenticationDialog: false // 是否显示弱实名弹框
  },
  mutations: {
    SET_SHOWAUTHENTICATIONDIALOG: (state, bool) => {
      state.showAuthenticationDialog = bool
    }
  },
  actions: {
  }
}

export default mineStore



// WEBPACK FOOTER //
// ./src/views/mine/mineStore.js